import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  FormHelperText,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
} from "@material-ui/core";
// FUNCIONES GENERALES
import AppBarModal from "../../general/AppBarModal";
import TareasTerminadas from "../../general/TareasTerminadas";
import { BtnForm } from "../../general/BotonesAccion";
import { crear_form_data, formulario, mostrarError, obtenerValoresFiltros } from "../../../global/js/funciones";
import { PLAN_ESTUDIO } from "../helper";
// IMAGENES
import emma_w from "../../../global/imagenes/emma_w.png";
import { actualizarMensaje } from "../../../redux/actions/actGlobal";

class SisefModificar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cargando: true,
      seleccion: "",
      planes: [],
      titulo_carg: "Cargando ..",
      // ===== IDENTIDAD ACADÉMICA =====
      codigo_asignatura: { valor: "", error: "" },
      asignatura_nombre: { valor: "", error: "" },
      codigo_programa: { valor: "", error: "" },
      programa_nombre: { valor: "", error: "" },
      codigo_departamento: { valor: "", error: "" },
      departamento_nombre: { valor: "", error: "" },

      // ===== INFORMACIÓN ACADÉMICA =====
      perfil_profesor: { valor: "", error: "" },
      perfil_formacion: { valor: "", error: "" },
      area_formacion: { valor: "", error: "" },
      nivel_formacion: { valor: "", error: "" },

      // ===== INTENSIDAD HORARIA =====
      horas_presenciales: { valor: "", error: "" },
      horas_trabajo_independiente: { valor: "", error: "" },
      total_horas: { valor: "", error: "" },
      creditos: { valor: "", error: "" },

      // ===== CONTENIDO =====
      pre_requisitos: { valor: "", error: "" },
      valores_plan: { valor: "", error: "" },
      resumen_plan: { valor: "", error: "" },

      // ===== CONTROL =====
      plan_syll: { valor: "", error: "" },
      periodo: { valor: "", error: "" },
    };
  }

  async componentDidMount() {
    this.setState({ cargando: false });
    this.obtenerDatosIniciales();
    this.cargarDatos()

  }
  // async componentDidUpdate({ modalModificarSisef }, { plan_syll_id }) {
  //   let { plan_syll_id: plan_syllNew } = this.state;
  //   let { modalModificarSisef: modalModificarSisefNew, cargarDatos } = this.props;
  //   if (modalModificarSisef !== modalModificarSisefNew || plan_syllNew !== plan_syll_id && cargarDatos) {
  //     this.setState({ cargando: true, cargarDatos: false,  })
  //     // this.obtenerDatos()
  //   }
  // }


  async obtenerDatosIniciales() {
    this.setState({ cargando: true });
    let planes = await obtenerValoresFiltros([
      { llave: "generica", valor: PLAN_ESTUDIO },
      { llave: "estado", valor: "1" },
    ]);
    this.setState({
      planes: planes.sort((a, b) => a.valora - b.valora),
      cargando: false,
    });
  }

  reiniciarEstado() {
    this.setState({
      cargando: true,
      seleccion: "",
    });
  }

  onChange = ({ target }) => {
    let { value, name } = target;
    this.setState({
      [name]: { valor: value },
    });
  };

  cargarDatos() {
    const { data_syllabus } = this.props;

    this.setState({
      codigo_asignatura: { valor: data_syllabus.codigo_asignatura || "" },
      asignatura_nombre: { valor: data_syllabus.asignatura_nombre || "" },
      codigo_programa: { valor: data_syllabus.codigo_programa || "" },
      programa_nombre: { valor: data_syllabus.programa_nombre || "" },
      codigo_departamento: { valor: data_syllabus.codigo_departamento || "" },
      departamento_nombre: { valor: data_syllabus.departamento_nombre || "" },
      perfil_profesor: { valor: data_syllabus.perfil_profesor || "" },
      perfil_formacion: { valor: data_syllabus.perfil_formacion || "" },
      area_formacion: { valor: data_syllabus.area_formacion || "" },
      nivel_formacion: { valor: data_syllabus.nivel_formacion?.id || "" },
      horas_presenciales: { valor: data_syllabus.horas_presenciales || "" },
      horas_trabajo_independiente: { valor: data_syllabus.horas_trabajo_independiente || "" },
      total_horas: { valor: data_syllabus.total_horas || "" },
      creditos: { valor: data_syllabus.creditos || "" },
      pre_requisitos: { valor: data_syllabus.pre_requisitos || "" },
      valores_plan: { valor: data_syllabus.valores_plan || "" },
      resumen_plan: { valor: data_syllabus.resumen_plan || "" },
      plan_syll: { valor: data_syllabus.plan_syll?.id || "" },
      periodo: { valor: data_syllabus.periodo || "" },
      cargando: false,
    });
  }


  onSubmit = (e) => {
    let {
      plan_syll,
      valores_plan,
      resumen_plan,
      perfil_profesor,
      codigo_programa,
      programa_nombre,
      codigo_departamento,
      departamento_nombre,
    } = this.state;
    let obligatorio = "Este campo es obligatorio";
    let error = false;
    if (!plan_syll.valor) {
      plan_syll.error = obligatorio;
      error = true;
    }
    if (!valores_plan.valor) {
      valores_plan.error = obligatorio;
      error = true;
    }
    if (!resumen_plan.valor) {
      resumen_plan.error = obligatorio;
      error = true;
    }
    if (!perfil_profesor.valor) {
      perfil_profesor.error = obligatorio;
      error = true;
    }
    if (codigo_programa.valor && !programa_nombre.valor) {
      programa_nombre.error = "Debe ingresar el nombre del programa";
      error = true;
    }
    if (programa_nombre.valor && !codigo_programa.valor) {
      codigo_programa.error = "Debe ingresar el código del programa";
      error = true;
    }
    if (codigo_departamento.valor && !departamento_nombre.valor) {
      departamento_nombre.error = "Debe ingresar el nombre del departamento";
      error = true;
    }
    if (departamento_nombre.valor && !codigo_departamento.valor) {
      codigo_departamento.error = "Debe ingresar el código del departamento";
      error = true;
    }
    if (!error) {
      this.enviarDatos();
    } else {
      this.setState({
        plan_syll,
        valores_plan,
        resumen_plan,
        perfil_profesor,
        codigo_programa,
        programa_nombre,
        codigo_departamento,
        departamento_nombre,
      });
    }
  };

  // Editar
  // EditarSyllabus = async (data) => {
  //   let { id_syllabus} = this.state;
  //   let {actualizarMensaje, mostrarModificarSisef,obtenerDatosIniciales}= this.props
  //   let form = await crear_form_data(data)
  //   formulario(
  //     `api/v1.0/sisef/${id_syllabus}/editar_syllabus`,
  //     form,
  //     "patch",
  //     (error, estado, resp) => {
  //       let titulo = "Ha ocurrido un error, contacte con el administrador.",
  //         tipo = "error";
  //       if (!error) {
  //         if (estado === 200) {
  //           tipo = "success";
  //           titulo = resp.titulo;
  //           obtenerDatosIniciales()
  //           mostrarModificarSisef(false)
  //         } else {
  //           tipo = "info";
  //           titulo = resp.titulo ? resp.titulo : mostrarError(resp);
  //         }
  //       }
  //       actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
  //     }
  //   );
  // };

  enviarDatos() {
    let {
      plan_syll,
      valores_plan,
      resumen_plan,
      perfil_profesor,
      codigo_programa,
      programa_nombre,
      codigo_departamento,
      departamento_nombre,
      perfil_formacion,
      area_formacion,
      creditos,
      horas_presenciales,
      horas_trabajo_independiente,
      total_horas,
      pre_requisitos,
      codigo_asignatura,
      asignatura_nombre,
    } = this.state;
    let { EditarSyllabus } = this.props;
    this.setState({ cargando: true, titulo_res: "Enviando.." });
    console.log("codigo_programa.valor ");
    console.log(codigo_programa.valor);
    let data = {
      codigo_programa: codigo_programa.valor,
      programa_nombre: programa_nombre.valor,
      codigo_departamento: codigo_departamento.valor,
      departamento_nombre: departamento_nombre.valor,
      plan_syll: plan_syll.valor,
      valores_plan: valores_plan.valor,
      resumen_plan: resumen_plan.valor,
      perfil_profesor: perfil_profesor.valor,
      perfil_formacion: perfil_formacion.valor,
      area_formacion: area_formacion.valor,
      creditos: creditos.valor,
      horas_presenciales: horas_presenciales.valor,
      horas_trabajo_independiente: horas_trabajo_independiente.valor,
      total_horas: total_horas.valor,
      pre_requisitos: pre_requisitos.valor,
      codigo_asignatura: codigo_asignatura.valor,
      asignatura_nombre: asignatura_nombre.valor,
    };
    EditarSyllabus(data);
  }

  conError(valor) {
    return valor ? true : false;
  }

  render() {
    let { modalModificarSisef, mostrarModificarSisef } = this.props;
    let {
      cargando,
      titulo_carg,
      planes,
      plan_syll,
      resumen_plan,
      perfil_profesor,
      valores_plan,
      codigo_asignatura, asignatura_nombre, codigo_programa,
      programa_nombre, codigo_departamento,
      departamento_nombre, perfil_formacion, area_formacion, horas_presenciales,
      horas_trabajo_independiente, total_horas, creditos,
      pre_requisitos, periodo,
    } = this.state;
    // let array=[{id: 1, nombre: "Matematica"}, {id: 2, nombre: "Competencias Ciudadanas"}, {id: 3, nombre: "Estructura de datos"}]
    return (

      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={modalModificarSisef}
        onClose={() => mostrarModificarSisef(false)}
      >
        <AppBarModal
          titulo={"¡ Plan de Asignatura Modificar !"}
          mostrarModal={() => mostrarModificarSisef(false)}
          titulo_accion="Cerrar"
          accion={() => mostrarModificarSisef(false)}
        />
        <DialogContent className="scroll">
          {!cargando ? (
            <Grid container spacing={3}>
              {this.props.administrador && (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Código de asignatura"
                      name="codigo_asignatura"
                      value={codigo_asignatura.valor}
                      onChange={this.onChange}
                      error={this.conError(codigo_asignatura.error)}
                      helperText={codigo_asignatura.error}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Nombre de asignatura"
                      name="asignatura_nombre"
                      value={asignatura_nombre.valor}
                      onChange={this.onChange}
                      error={this.conError(asignatura_nombre.error)}
                      helperText={asignatura_nombre.error}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Código de programa"
                      name="codigo_programa"
                      value={codigo_programa.valor}
                      onChange={this.onChange}
                      error={this.conError(codigo_programa.error)}
                      helperText={codigo_programa.error}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Nombre del programa"
                      name="programa_nombre"
                      value={programa_nombre.valor}
                      onChange={this.onChange}
                      error={this.conError(programa_nombre.error)}
                      helperText={programa_nombre.error}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Código del departamento"
                      name="codigo_departamento"
                      value={codigo_departamento.valor}
                      onChange={this.onChange}
                      error={this.conError(codigo_departamento.error)}
                      helperText={codigo_departamento.error}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Departamento"
                      name="departamento_nombre"
                      value={departamento_nombre.valor}
                      onChange={this.onChange}
                      error={this.conError(departamento_nombre.error)}
                      helperText={departamento_nombre.error}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        id="perfil_formacion"
                        name="perfil_formacion"
                        label="Perfil de formación"
                        multiline
                        minRows={5}
                        maxRows={10}
                        value={perfil_formacion.valor}
                        onChange={this.onChange}
                        error={this.conError(perfil_formacion.error)}
                        helperText={perfil_formacion.error}
                        variant="outlined"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Área de formación"
                      name="area_formacion"
                      value={area_formacion.valor}
                      onChange={this.onChange}
                      error={this.conError(area_formacion.error)}
                      helperText={area_formacion.error}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="Horas presenciales"
                      name="horas_presenciales"
                      value={horas_presenciales.valor}
                      onChange={this.onChange}
                      error={this.conError(horas_presenciales.error)}
                      helperText={horas_presenciales.error}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="Horas trabajo independiente"
                      name="horas_trabajo_independiente"
                      value={horas_trabajo_independiente.valor}
                      onChange={this.onChange}
                      error={this.conError(horas_trabajo_independiente.error)}
                      helperText={horas_trabajo_independiente.error}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="Total horas"
                      name="total_horas"
                      value={total_horas.valor}
                      onChange={this.onChange}
                      error={this.conError(total_horas.error)}
                      helperText={total_horas.error}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="Créditos"
                      name="creditos"
                      value={creditos.valor}
                      onChange={this.onChange}
                      error={this.conError(creditos.error)}
                      helperText={creditos.error}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      label="Pre requisitos"
                      name="pre_requisitos"
                      value={pre_requisitos.valor}
                      onChange={this.onChange}
                      error={this.conError(pre_requisitos.error)}
                      helperText={pre_requisitos.error}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Periodo"
                      name="periodo"
                      value={periodo.valor}
                      onChange={this.onChange}
                      error={this.conError(periodo.error)}
                      helperText={periodo.error}
                      fullWidth
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <FormControl
                  className="form-control"
                  fullWidth
                  error={this.conError(plan_syll.error)}
                >
                  <InputLabel id="plan_estudio_syll_label">
                    Plan de estudio
                  </InputLabel>
                  <Select
                    labelId="plan_estudio_syll_label"
                    name="plan_syll"
                    value={plan_syll.valor}
                    onChange={this.onChange}
                  >
                    {planes.map((plan) => (
                      <MenuItem key={plan.id} value={plan.id}>
                        {plan.nombre}
                      </MenuItem>
                    ))}
                  </Select>
                  {plan_syll.error && (
                    <FormHelperText>{plan_syll.error}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="valores_plan"
                  label="Valores"
                  multiline
                  minRows={4}
                  value={valores_plan.valor}
                  onChange={this.onChange}
                  error={this.conError(valores_plan.error)}
                  helperText={valores_plan.error}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="perfil_profesor"
                  label="Perfil del profesor"
                  multiline
                  minRows={4}
                  value={perfil_profesor.valor}
                  onChange={this.onChange}
                  error={this.conError(perfil_profesor.error)}
                  helperText={perfil_profesor.error}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="resumen_plan"
                  label="Resumen"
                  multiline
                  minRows={4}
                  value={resumen_plan.valor}
                  onChange={this.onChange}
                  error={this.conError(resumen_plan.error)}
                  helperText={resumen_plan.error}
                  fullWidth
                />
              </Grid>
            </Grid>
          ) : (
            <TareasTerminadas
              mensaje={titulo_carg}
              marginTop="7%"
              imagen={emma_w}
              widthImg="7%"
            />
          )}
        </DialogContent>
        <DialogActions>
          <BtnForm
            texto="CANCELAR"
            callback={() => mostrarModificarSisef(false)}
          />
          {!cargando && <BtnForm texto="Modificar" callback={this.onSubmit} />}
        </DialogActions>
      </Dialog>
    );
  }

}

SisefModificar.propTypes = {
  mostarmodificarSisef: PropTypes.func.isRequired,
  modalModificarSisef: PropTypes.bool.isRequired,
  actualizarMensaje: PropTypes.func.isRequired,
};

export default SisefModificar;
